import { produce } from "immer";
import { theme } from "../../theme/theme";
import { CLEAR_ALL_ERROR_MESSAGE, CLEAR_ERROR_MESSAGE, LOAD_API_DATA, SET_API_DATA, SET_ERROR_MESSAGE, SET_FORM_OPTION, SET_FORM_VALUE, SET_FORM_VALUEOBJ } from "./dataSubDomain.type";
const INITAL_STATE = {
    apiData: {
        supplyDomain: {
            status: "idle",
            data: {
                description: "This table contains data related advertising brands campaigns on Amazon. It includes information such as the search terms used, the date of the campaign, the type of match used, the campaign status, and the campaign budget amount. Additionally, it provides data on various performance metrics, such as attributed sales, ROAS (Return on Ad Spend), units sold, sales of other SKUs, purchases, and cost per click. This table is essential for analyzing the effectiveness and profitability of advertising campaigns and optimizing future strategies.",
                dataList: [{ title: "Active Rules", value: "10", color: theme.colors.primary },
                { title: "Successful runs in last 30 days", value: "140 of 180", color: theme.colors.primary },
                { title: "Freshness", value: "25%", color: parseInt("25%".split("%")[0]) <= 55 ? theme.colors.fail : parseInt("25%".split("%")[0]) >= 85 ? theme.colors.success : theme.colors.primary },
                { title: "Total Quality Score", value: "92.6%", color: theme.colors.success },
                { title: "Last Update on", value: "02 days ago", color: theme.colors.primary },
                ],
                country: "United Kingdom",
                data_prod_name: "Amazon",
                region: "EU",
                domain: "Advertising",
                created_by: "Veronika Lutfullina",
                chartData: [{
                    title: "Manufacturing",
                    description: "Optimizes manufacturing operations by managing data related to production processes, scheduling, and capacity. This enables efficient resource utilization, minimizes downtime, and ensures consistent quality across production lines, leading to cost savings and improved operational performance.",
                    ruleCount: 5,
                    qualityScore: "100%",
                    updated: "31 days ago",
                    createdAt:"21/11/24"
                },
                {
                    title: "Planning",
                    description: "Centralizes and analyzes data related to demand forecasting, production scheduling, and resource planning. It helps streamline the planning process, ensuring that resources are allocated effectively, production timelines are met, and inventory levels are optimized to avoid stockouts or overstocking.",
                    ruleCount: 5,
                    qualityScore: "60%",
                    updated: "34 days ago",
                    createdAt:"21/11/24"
                },
                {
                    title: "Physical Logistics",
                    description: "Manages data for the physical movement of goods, including transportation, warehousing, and distribution. It helps optimize logistics operations, reduce transportation costs, and improve delivery accuracy, ensuring that products are delivered on time and in the right quantities.",
                    ruleCount: 5,
                    qualityScore: "30%",
                    updated: "39 days ago",
                    createdAt:"21/11/24"
                },
                {
                    title: "Commercial",
                    description: "Integrates data from sales, marketing, and customer interactions to drive commercial strategies. It enables better decision-making regarding pricing, promotions, and market positioning, enhancing customer engagement, boosting sales, and maximizing revenue growth.",
                    ruleCount: 5,
                    qualityScore: "45%",
                    updated: "34 days ago",
                    createdAt:"21/11/24"
                },
                {
                    title: "Network Design",
                    description: "Focuses on optimizing the design and structure of the supply chain network. It involves analyzing data to improve distribution, warehouse locations, and transportation routes, ensuring cost-effective and efficient delivery of goods while meeting customer demand.",
                    ruleCount: 5,
                    qualityScore: "80%",
                    updated: "40 days ago",
                    createdAt:"21/11/24"
                },
                {
                    title: "Inventory",
                    description: "Manages inventory data across the supply chain, ensuring accurate stock levels, minimizing excess inventory, and improving replenishment strategies. It helps maintain optimal inventory levels, reduce carrying costs, and enhance order fulfillment accuracy to meet customer demand effectively.",
                    ruleCount: 5,
                    qualityScore: "70%",
                    updated: "3 days ago",
                    createdAt:"21/11/24"
                }]
            },
            isError: false,
            errorMessage: "",
            loading: false
        },
        masterDataDomain: {
            status: "idle",
            data: {
                description: "Master Data unifies and manages vendor, supply, R&D, finance, consumer, product, customer, geographic, promotion, and sales force data, ensuring consistency, accuracy, and accessibility to support efficient operations, strategic decision-making, and seamless collaboration across diverse business functions.",
                dataList: [{ title: "Active Rules", value: "10", color: theme.colors.primary },
                { title: "Successful runs in last 30 days", value: "140 of 180", color: theme.colors.primary },
                { title: "Freshness", value: "25%", color: parseInt("25%".split("%")[0]) <= 55 ? theme.colors.fail : parseInt("25%".split("%")[0]) >= 85 ? theme.colors.success : theme.colors.primary },
                { title: "Total Quality Score", value: "92.6%", color: theme.colors.success },
                { title: "Last Update on", value: "02 days ago", color: theme.colors.primary },
                ],
                country: "United Kingdom",
                data_prod_name: "Amazon",
                region: "EU",
                domain: "Advertising",
                created_by: "Veronika Lutfullina",
                chartData: [{
                    title: "Vendor",
                    description: "Centralizes and manages vendor and supplier information, streamlining procurement processes, improving vendor relationships, and ensuring efficient contract and compliance management. This data helps in monitoring supplier performance, negotiating better terms, and driving cost savings through strategic vendor management.",
                    ruleCount: 5,
                    qualityScore: "100%",
                    updated: "31 days ago",
                    createdAt:"21/11/24"
                },
                {
                    title: "Supply",
                    description: "Aggregates and analyzes supply chain data to optimize resource allocation, production scheduling, logistics, and inventory management. It helps improve operational efficiency, reduce stockouts, manage costs effectively, and enable faster responses to market changes and demand fluctuations.",
                    ruleCount: 5,
                    qualityScore: "60%",
                    updated: "34 days ago",
                    createdAt:"21/11/24"
                },
                {
                    title: "R&D",
                    description: "Supports research and development activities by organizing and managing data related to concept design, experiments, product formulations, and regulatory compliance. This ensures that product innovation is driven by accurate data and streamlined processes, helping reduce time-to-market while meeting industry standards and regulations.",
                    ruleCount: 5,
                    qualityScore: "30%",
                    updated: "39 days ago",
                    createdAt:"21/11/24"
                },
                {
                    title: "Finance",
                    description: "Ensures accurate management and reporting of financial data, providing insights into budgeting, forecasting, and financial compliance. It supports strategic decision-making, financial planning, and helps in monitoring and controlling costs, thus enabling businesses to make informed decisions and maintain fiscal discipline.",
                    ruleCount: 5,
                    qualityScore: "45%",
                    updated: "34 days ago",
                    createdAt:"21/11/24"
                },
                {
                    title: "Consumer",
                    description: "Centralizes consumer data, including behavior, preferences, and demographics, to enhance engagement strategies. It helps businesses understand customer needs, personalize marketing efforts, improve customer experience, and tailor products and services to maximize satisfaction and loyalty.",
                    ruleCount: 5,
                    qualityScore: "80%",
                    updated: "40 days ago",
                    createdAt:"21/11/24"
                },
                {
                    title: "Product",
                    description: "Manages detailed product data, such as specifications, performance tracking, and lifecycle management. This ensures consistency across the product portfolio, helps in identifying areas for improvement, drives product innovation, and maintains high-quality standards throughout the product’s life cycle.",
                    ruleCount: 5,
                    qualityScore: "70%",
                    updated: "3 days ago",
                    createdAt:"21/11/24"
                },
                {
                    title: "Customer",
                    description: "Centralizes comprehensive customer data to improve engagement, retention, and service delivery. By analyzing customer touchpoints, behaviors, and preferences, businesses can enhance customer interactions, customize offerings, and develop stronger, long-lasting relationships, leading to improved loyalty and lifetime value.",
                    ruleCount: 5,
                    qualityScore: "55%",
                    updated: "2 days ago",
                    createdAt:"21/11/24"
                }]
            },
            isError: false,
            errorMessage: "",
            loading: false
        }

    },
    formData: {
        country: {
            value: "",
            valueAsObj: {},
            options: [{ country: 'USA' },],
            loading: false,
            isError: false,
            errorMessage: ""
        },
    }

}

const subDomainReducer = (state = INITAL_STATE, { type, payload }) => {
    switch (type) {
        case SET_FORM_VALUE: {

            return produce(state, (draft) => {

                draft.formData[payload.formField].value = payload.value
            });
        }
        case SET_FORM_VALUEOBJ: {
            return produce(state, (draft) => {
                draft.formData[payload.formField].valueAsObj = payload.valueAsObj
            });
        }
        case SET_ERROR_MESSAGE: {
            return produce(state, (draft) => {
                draft.formData[payload.formField].isError = payload.isError
                draft.formData[payload.formField].errorMessage = payload.errorMessage
            });
        }
        case CLEAR_ERROR_MESSAGE: {
            return produce(state, (draft) => {
                draft.formData[payload.formField].isError = false
                draft.formData[payload.formField].errorMessage = ""
            });
        }
        case CLEAR_ALL_ERROR_MESSAGE: {
            return produce(state, (draft) => {
                Object.keys(draft.formData).forEach((val) => {
                    draft.formData[val].isError = false
                    draft.formData[val].errorMessage = ""
                })

            });
        }
        case LOAD_API_DATA:
            return produce(state, (draft) => {
                draft.apiData[payload.apiField].loading = true
                draft.apiData[payload.apiField].status = "loading"
            })
        case SET_API_DATA:
            return produce(state, (draft) => {
                draft.apiData[payload.apiField].loading = false;
                draft.apiData[payload.apiField].status =
                    payload.status !== undefined && payload.status !== null
                        ? payload.status
                        : "success";
                draft.apiData[payload.apiField].data = payload.data;
            });
        case SET_FORM_OPTION:
            return produce(state, (draft) => {
                draft.formData[payload.formField].loading = false;
                draft.formData[payload.formField].options = payload.data;
            });
        // Return the current state if no action matches
        default:
            return state;
    }
}
export default subDomainReducer;